// src/components/User/Footer.js
import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer
            className="px-6 md:px-12 lg:px-36 py-14 border-t border-[rgba(0,0,0,0.06)]"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[1000px] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
                {/* Left: Identity & Direct Contact */}
                <div>
                    <h3
                        className="text-lg md:text-xl font-bold tracking-tight"
                        style={{ color: "var(--text-primary)" }}
                    >
                        Anindya Chowdhury
                    </h3>
                    <p
                        className="text-sm mt-0.5"
                        style={{ color: "var(--text-secondary)" }}
                    >
                        Consumer Growth &amp; Product Advisor
                    </p>
                    <div className="mt-3 flex items-center gap-3 text-sm">
                        <a
                            href="https://www.linkedin.com/in/anindya114/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="font-medium hover:underline transition"
                            style={{ color: "var(--color-primary)" }}
                        >
                            LinkedIn
                        </a>
                        <span style={{ color: "var(--text-secondary)" }}>·</span>
                        <a
                            href="mailto:anindya@buzztobrand.com"
                            className="font-medium hover:underline transition"
                            style={{ color: "var(--color-primary)" }}
                        >
                            Email
                        </a>
                    </div>
                </div>

                {/* Right: Copyright & Legal */}
                <div
                    className="flex flex-col md:items-end gap-2 text-xs sm:text-sm"
                    style={{ color: "var(--text-secondary)" }}
                >
                    <p>© 2026 Anindya Chowdhury</p>
                    <div className="flex items-center gap-3">
                        <Link
                            to="/privacy-policy"
                            className="hover:text-[var(--text-primary)] hover:underline transition"
                        >
                            Privacy Policy
                        </Link>
                        <span>·</span>
                        <Link
                            to="/terms-and-conditions"
                            className="hover:text-[var(--text-primary)] hover:underline transition"
                        >
                            Terms
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
